module.exports = __webpack_public_path__ + "img/Hannah-Skaggs.c29eef25.jpeg";